var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHatvHoverArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#F4F4F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5234 21.0586L21.8984 26.6836C21.4766 27.1406 20.7383 27.1406 20.3164 26.6836C19.8594 26.2617 19.8594 25.5234 20.3164 25.1016L24.0078 21.375H13.25C12.6172 21.375 12.125 20.8828 12.125 20.25C12.125 19.6523 12.6172 19.125 13.25 19.125H24.0078L20.3164 15.4336C19.8594 15.0117 19.8594 14.2734 20.3164 13.8516C20.7383 13.3945 21.4766 13.3945 21.8984 13.8516L27.5234 19.4766C27.9805 19.8984 27.9805 20.6367 27.5234 21.0586Z",
    fill: "#007775"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHatvHoverArrow);
export default __webpack_public_path__ + "static/media/hatv_hover_arrow.ca3d3ec876212dcf98e52b28290d27a8.svg";
export { ForwardRef as ReactComponent };